import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import { Common } from '../core/common';

const T = Translator.create();
let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const _logger = Log.create('VirtualClass-Service');

export class EnrollmentService {

    constructor() {
        _apiClient = new ApiClient();
    }

    // Get Lesson-Page Header Information
    public async RequestGetEnrollmentActivityAsync(activityId: any) {
        const _common = new Common();
        return _apiClient.RequestAsync('POST', 'api/enrollment/get', activityId, token).then((responseData: Response) => {
            if (responseData.status !== 200) {
                Notification.setNotification('error', T.t('r_api_enrollment_noaction'), 'topRight');
                return null;
            } else {
                return responseData.json();
            }
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return false;
        });
    }

    public async RequestAddEnrollmentActionAsync(params:any) {
        const _common = new Common();

        return _apiClient.RequestAsync('POST', 'api/enrollment/addaction', params).then((responseData: Response) => {
            if (responseData.status !== 200) {
                Notification.setNotification('error', T.t('r_api_gen_taskDeadlineIsPassed'), 'topRight');
                return null;
            } else {
                return responseData.json();
            }
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return false;
        });
    }

    public async RequestGetMyGradesAsync(params: any) {
        return _apiClient.RequestAsync('GET', 'api/enrollment/mygrades' + '?Take=' + params.Take + '&Skip=' + params.Skip + '&lastActivityId=' + params.lastActivityId, null, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestRefreshMyEnrollments() {
        return _apiClient.RequestAsync('GET', 'api/enrollment/refresh', null, token).then((responseData: Response) => {
            return responseData.json();
        }).catch((responseData) => {
            Notification.setNotification('error', T.t('r_api_enrollment_noaction'), 'topRight');
            return responseData;
        });
    }

}

